import React from 'react';

import FullPageTerminalStateLayout from 'src/components/creditApplication/FullPageTerminalStateLayout';
import { NavigationContext } from 'src/components/creditApplication/NavigationProvider';

const SSNVerifiedPage = () => {
  const { nextPage, nextPageLoading } = React.useContext(NavigationContext);

  return (
    <FullPageTerminalStateLayout
      title='Your Social Security Number&nbsp;is&nbsp;verified'
      subtitle='Thank you for your patience.'
      buttonLabel='Continue'
      buttonType='submit'
      onButtonPress={nextPage}
      buttonState={nextPageLoading ? 'loading' : 'default'}
    />
  );
};

export default SSNVerifiedPage;
